import React from "react";
import { Link } from "react-router-dom";
import { IJobView } from "../interfaces/job/iJobView.interface";
import {
  MapPinIcon,
  CurrencyEuroIcon,
  ArrowRightIcon,
} from "./../icons/SvgIcons";
import { primaryBtnModernClasses } from "../styles/uiClasses";
import { sectionCardCompactClasses } from "../styles/pageClasses";
import { jobCardClasses } from "../styles/componentClasses";

function SavedBadge({ className = "" }: { className?: string }) {
  return (
    <span
      className={`${jobCardClasses.savedBadge} ${className}`}
      title="Saved"
    >
      <svg
        viewBox="0 0 20 20"
        fill="currentColor"
        className={jobCardClasses.savedBadgeIcon}
        aria-hidden="true"
      >
        <path
          fillRule="evenodd"
          d="M5 3a2 2 0 00-2 2v12.586a1 1 0 001.707.707L10 14.414l5.293 3.879A1 1 0 0017 17.586V5a2 2 0 00-2-2H5z"
          clipRule="evenodd"
        />
      </svg>
      <span className={jobCardClasses.savedBadgeSrOnly}>Saved</span>
    </span>
  );
}

export function JobCard({
  job,
  to,
  primaryLabel = "View Details",
  secondaryAction,
  className = "",
  isSaved,
}: {
  job: IJobView;
  to: string;
  primaryLabel?: string;
  secondaryAction?: React.ReactNode;
  className?: string;
  isSaved: boolean;
}) {
  const where = job.locationName;
  const region = job.locationRegionName;
  const date = job.createdDate ? new Date(job.createdDate) : null;
  const saved = typeof isSaved === "boolean" ? isSaved : job.isSaved;

  return (
    <div
      className={`${jobCardClasses.wrapper} ${sectionCardCompactClasses} ${className}`}
    >
      <div className={jobCardClasses.inner}>
        <div className={jobCardClasses.hoverGlow} />

        <div className={jobCardClasses.content}>
          <div className={jobCardClasses.header}>
            <div className={jobCardClasses.titleWrap}>
              <h3 className={jobCardClasses.title}>
                {job.title}
              </h3>
            </div>

            <div className={jobCardClasses.badgeRow}>
              {job.jobCategoryName && (
                <span className={jobCardClasses.categoryBadge}>
                  {job.jobCategoryName}
                </span>
              )}
              {saved && <SavedBadge />}
            </div>
          </div>

          {job.companyName && (
            <p className={jobCardClasses.company}>{job.companyName}</p>
          )}

          <div className={jobCardClasses.metaList}>
            {(where || region) && (
              <div className={jobCardClasses.metaRow}>
                <MapPinIcon className={jobCardClasses.metaIcon} /> {where}
                {region ? `, ${region}` : ""}
              </div>
            )}

            {typeof job.salary === "number" && (
              <div className={jobCardClasses.currencyRow}>
                <CurrencyEuroIcon className={jobCardClasses.metaIcon} />
                EUR {Number(job.salary).toLocaleString()}
              </div>
            )}
          </div>

          <div className={jobCardClasses.descriptionWrap}>
            {job.description && (
              <p className={jobCardClasses.description}>{job.description}</p>
            )}
          </div>

          <div className={jobCardClasses.footer}>
            <span className={jobCardClasses.date}>
              {date ? `Posted ${date.toLocaleDateString()}` : ""}
            </span>
            <div className={jobCardClasses.actions}>
              {secondaryAction}
              <Link
                to={to}
                className={`${jobCardClasses.primaryLink} ${primaryBtnModernClasses}`}
              >
                {primaryLabel} <ArrowRightIcon className={jobCardClasses.primaryLinkIcon} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
